import { Icons } from '@mnd-frontend/ui/publish/components';
import { MEDIA_SMALL } from '@mnd-frontend/ui/shared/tokens';
import { useWidget, WIDGETS } from '../../../../../contexts/WidgetContext';
import WidgetTrigger from '../WidgetTrigger';
import WidgetWrapper from '../WidgetWrapper';

const Chat = ({ hide }: { hide?: boolean }) => {
  const isMobile = window.innerWidth < MEDIA_SMALL;
  const { widget, toggleWidget } = useWidget();

  if (isMobile) return null;
  return (
    <>
      <WidgetTrigger
        svg={<Icons.Chat />}
        hide={hide}
        open={widget === WIDGETS.CHAT}
        onClick={() => toggleWidget(WIDGETS.CHAT)}
      />
      <WidgetWrapper open={hide ? false : widget === WIDGETS.CHAT}>
        <div id="olark-box-container"></div>
      </WidgetWrapper>
    </>
  );
};

export default Chat;
